/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagerUnregisterResponse } from "./MemberManagerUnregisterResponse";

export type MemberManagerUnregisterResponseApiRespoonse = {
  data?: MemberManagerUnregisterResponse;
  status?: MemberManagerUnregisterResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberManagerUnregisterResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
